import { memo, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { CameraAltOutlined } from '@material-ui/icons'

import { getIsSnapshotInProgress } from '@tabeeb/modules/presentationToolbar/selectors'
import * as snapshotActions from '@tabeeb/modules/presentationToolbar/actions/snapshot'

import ToolbarButton from '@tabeeb/modules/playerToolbar/components/ToolbarButton'

const SnapshotButton = () => {
  const dispatch = useDispatch()

  const snapshotInProgress = useSelector(getIsSnapshotInProgress)

  const onClick = useCallback(() => {
    if (snapshotInProgress) {
      return
    }

    dispatch(snapshotActions.onSnapshotTaking())
  }, [dispatch, snapshotInProgress])

  return <ToolbarButton Icon={CameraAltOutlined} title='Take a snapshot' onClick={onClick} />
}

export default memo(SnapshotButton)
